interface StatusStyle {
  bg: string
  text: string
  dot: string
}

const statusStyles: Record<string, StatusStyle> = {
  import: { bg: 'bg-blue-50', text: 'text-blue-800', dot: 'bg-blue-500' },
  pending: { bg: 'bg-emerald-50', text: 'text-emerald-800', dot: 'bg-emerald-500' },
  partial: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
  delivered: { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' },
  cancelled: { bg: 'bg-red-50', text: 'text-red-800', dot: 'bg-red-500' },
  archived: { bg: 'bg-gray-100', text: 'text-gray-500', dot: 'bg-gray-400' },
}

const defaultStyle: StatusStyle = {
  bg: 'bg-gray-100',
  text: 'text-gray-600',
  dot: 'bg-gray-400',
}

export function getStatusStyle(status: string | null): StatusStyle {
  if (!status) return defaultStyle
  return statusStyles[status.toLowerCase()] ?? defaultStyle
}

const statusLabels: Record<string, string> = {
  import: 'Importert',
  pending: 'Klargjort',
  partial: 'Venter deler',
  delivered: 'Utlevert',
  cancelled: 'Kansellert',
  archived: 'Arkivert',
}

export function getStatusLabel(status: string | null): string {
  if (!status) return 'Ukjent'
  return statusLabels[status.toLowerCase()] ?? status
}
